import type { ComponentProps } from "react"

export default function IndustryB(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M24 8.00004C15.5107 -0.481291 8.91067 3.69338 8.91067 3.69338C11.9274 5.18589 14.6619 7.19128 16.992 9.62004L14.8373 13.9307L16.4533 15.5467L18.0693 17.1627L22.38 15.008C24.8088 17.3382 26.8141 20.0726 28.3067 23.0894C28.3067 23.0894 32.4813 16.4894 24 8.00004ZM14.0973 16.0174L1.724 28.3907L3.60933 30.276L15.9827 17.9027L15.04 16.96L14.0973 16.0174Z"
        fill={fill}
      />
    </svg>
  )
}
